module.exports = __webpack_public_path__ + "img/predokenske_rolete.dc292555.svg";